import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { changeScreenB } from '../../../store/actions/navigation.action'
import { AppBar, Avatar, Button, CardHeader, Checkbox, FormControlLabel, Toolbar, IconButton, Typography, TextField, Divider, Dialog } from '@material-ui/core'
import { search, indexResponse } from '../../../store/actions/cotas.action'
import { changeScreen } from '../../../store/actions/navigation.action'
import { MdKeyboardBackspace, MdClose } from 'react-icons/md'
import { FaEyeSlash, FaSearch, FaUser, FaDownload, FaCheck } from 'react-icons/fa'
import { IoLogoWhatsapp } from "react-icons/io"
import MaskedInput from 'react-text-mask'
import Fullname from '../../components/Fullname'
import { redirectView } from '../../../store/actions/transaction.action'
import Detail from '../transactions/detail'

const TextMaskCustom = (props) => {
    const { inputRef, ...other } = props;
    let mask = [];

    if (props.name === 'int') {
        mask = [/[0-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]
    }

    return (
        <MaskedInput
            {...other}
            ref={ref => {
                inputRef(ref ? ref.inputElement : null)
            }}
            mask={mask}
            guide={false}
        />
    )
}

export default function Consult(props) {
    const dispatch = useDispatch()
    const { result } = useSelector(state => state.cotasReducer)
    const campaign_id = (props.uid) ? props.uid : null

    const [number, setNumber] = React.useState('')
    const [ telefone, setTelefone ] = React.useState(false)
    const [checked, setChecked] = React.useState(false)

    const [detail, setDetail] = React.useState({
        id: null,
        open: false,
        user_id: null
    })
    
    const handleReserved = async (event) => {
        setChecked(event.target.checked)
        await localStorage.setItem('reserved', event.target.checked)
    }

    React.useEffect(async () => {
        let value = await localStorage.getItem('reserved')
        if(value) {
            setChecked(value)
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    React.useEffect(() => {
        if(checked === 'true') {
            setChecked(true)
        }
        if(checked === 'false') {
            setChecked(false)
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [checked])

    React.useEffect(() => {
        return () => {
            dispatch(indexResponse({
                result: {
                    cota: {},
                    transaction: {},
                    user: {},
                    error: null
                }
            }))
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handlePage = (page, user_id = null) => {
        dispatch(changeScreenB({
            open: true,
            type: page,
            props: {
                user_id: user_id
            }
        }))
    }

    const _detail = (id, user_id) => {
        setDetail({
            id: id,
            open: true,
            user_id: user_id
        })
    }

    const _handleRedirectView = (id, url) => {
        dispatch(redirectView(id, url))
    }

    return (
        <div className="app-bar">
            <AppBar position="fixed">
                <Toolbar>
                    <IconButton onClick={() => dispatch(changeScreen({ open: false }))} edge="start" color="inherit">
                        <MdKeyboardBackspace />
                    </IconButton>
                    <Typography variant="h6">Consultar</Typography>

                    <Button 
                        disabled={(number === '')}
                        variant="contained" 
                        size="small" 
                        onClick={() => number !== '' && dispatch(search(campaign_id, number, checked))}
                        color="inherit" 
                        className="ms-auto btn-app-bar"
                        startIcon={<FaSearch />}
                        
                    >
                        Pesquisar
                    </Button>

                </Toolbar>
            </AppBar>

            <Dialog
                open={detail.open}
                maxWidth="sm"
                style={{width: '100%'}}
                onClose={() => setDetail({ id: null, open: false })}
                className="center"
            >   
                <Detail uid={detail.id} user_id={detail.user_id} onClose={() => setDetail({ id: null, open: false, user_id: null })}/>
            </Dialog>

            <div className="card card-body mt-3 bs-bg">
                <div className="mb-3">
                    <FormControlLabel
                        className="bs-color-b"
                        control={
                        <Checkbox
                            checked={(checked === 'false' || checked === false ) ? false : true}
                            onChange={handleReserved}
                            name="reserved"
                            color="primary"
                        />
                        }
                        label={<span>Mostrar Última Reserva</span>}
                    />
                </div>

                <div className={result.cota.number ? "mb-3" : "mb-5"}>
                    <label className="label-custom bs-color-b">Pesquisar Cota</label>
                    <TextField
                        name="int"
                        type="tel"
                        className="fw-bold"
                        InputProps={{
                            inputComponent: TextMaskCustom,
                            value: number,
                            placeholder: 'Ex: 1584690',
                            onChange: text => {
                                setNumber(text.target.value)
                                if(result.cota || result.error) {
                                    dispatch(indexResponse({
                                        result: {
                                            cota: {},
                                            transaction: {},
                                            user: {},
                                            error: null
                                        }
                                    }))
                                }
                            }
                        }}
                    />
                </div>

                {(result.cota && !result.user && !result.user_reserved) &&
                    <div className="alert alert-success mt-3" role="alert">
                        Cota disponivel para compra
                    </div>
                }

                {(result.cota && result.user_reserved) &&
                <>
                    <label className="card-body label-custom m-0 pb-1 bs-color-b">Cota</label>
                    <CardHeader 
                        avatar={
                            <Avatar className="bg-danger">
                                <MdClose />
                            </Avatar>
                        }
                        title={<h3 className="fw-bold m-0 bs-color-b">{result.cota.number}</h3>}
                        subheader={<small className="fw-bold text-danger">PAGAMENTO EXPIRADO</small>} 
                    />

                    <hr className="hr-muted m-0"/>

                    <label className="card-body label-custom m-0 pb-1 bs-color-b">Cliente</label>
                    <CardHeader 
                        avatar={
                            <Avatar className="avatar-item">
                                <FaUser />
                            </Avatar>
                        }
                        title={<h6 className="fw-bold bs-color-b">{<Fullname fullName={result.user_reserved.name ? result.user_reserved.name.substring(0,25) : result.user_reserved.name} />}</h6>}
                        subheader={
                            <>
                            <div className="d-flex flex-column mb-2">
                                <span className="d-block pointer bs-color">{result.user_reserved.telefone ? result.user_reserved.telefone.substring(0,5) : result.user_reserved.telefone}**-****</span>
                                {result.transaction_reserved?.location &&
                                    <span className="bs-color">{result.transaction_reserved?.location?.estado}</span>
                                }
                            </div>
                            <span onClick={() => handlePage('shopping', result.user_reserved.id)} className="pointer fw-bold text-danger">Todas compras</span>
                            </>
                        }
                    /> 

                    <hr className="hr-muted m-0"/>

                    <label className="card-body label-custom m-0 pb-1 bs-color-b">Transação</label>
                    <CardHeader 
                        avatar={
                            <Avatar className="avatar-item">
                                <FaDownload />
                            </Avatar>
                        }
                        title={<h6 className="fw-bold bs-color-b">{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(result.transaction_reserved.transaction_amount)}</h6>}
                        subheader={
                            <>
                            <span className="d-block bs-color">Horário: {new Intl.DateTimeFormat('pt-BR', {year: '2-digit', month: '2-digit',day: '2-digit'}).format(new Date(result.transaction_reserved.created_at))} {new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(result.transaction_reserved.created_at))}</span>
                            <span className="d-block bs-color">Expirado em: {new Intl.DateTimeFormat('pt-BR', {year: '2-digit', month: '2-digit',day: '2-digit'}).format(new Date(result.transaction_reserved.expired_at))} {new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(result.transaction_reserved.expired_at))}</span>
                            <span className="d-block bs-color">ID Transação: <span className="bs-color-b">{result.transaction_reserved.id}</span></span>
                            </>
                        }
                    />
                </>
                }

                {(result.cota && result.user) &&
                <>
                    {(result.cota.number && result.user.name) &&
                        <>
                            <label className="card-body label-custom m-0 pb-1 bs-color-b">Cota</label>
                            <CardHeader 
                                avatar={
                                    <Avatar className="bg-success">
                                        <FaCheck />
                                    </Avatar>
                                }
                                title={<h5 className="fw-bold m-0 bs-color-b">{result.cota.number}</h5>}
                                subheader={<small className="fw-bold text-success">VENDIDA</small>} 
                            />

                            <hr className="hr-muted m-0"/>

                            <label className="card-body label-custom m-0 pb-1 bs-color-b">Cliente</label>
                            <CardHeader 
                                avatar={
                                    <Avatar className="avatar-item">
                                        <FaUser />
                                    </Avatar>
                                }
                                title={<h6 className="fw-bold bs-color-b">{<Fullname fullName={result.user.name ? result.user.name.substring(0,25) : result.user.name} />}</h6>}
                                subheader={
                                    <>
                                    <div className="d-flex justify-content-between">
                                        <div className="d-flex flex-column mb-2">
                                            <span className="d-block pointer bs-color" onClick={() => setTelefone(telefone ? false : true)}>{(telefone) ? result.user.telefone : <> {result.user.telefone.substring(5, -1)} ****** <FaEyeSlash /></>}</span>
                                            {result.transaction?.location &&
                                                <span className="bs-color">{result.transaction?.location?.estado}</span>
                                            }
                                        </div>

                                        <span className="me-2">
                                            <a href={'http://wa.me/55'+result.user.telefone} target="_blank" rel="noopener noreferrer">
                                                <IoLogoWhatsapp color="#24d366" size={30}/>
                                            </a>
                                        </span>
                                    </div>

                                    <span onClick={() => handlePage('shopping', result.user.id)} className="pointer fw-bold text-danger">Todas compras</span>
                                    </>
                                }
                            /> 

                            <hr className="hr-muted m-0"/>

                            <label className="card-body label-custom m-0 pb-1 bs-color-b">Transação</label>
                            <CardHeader 
                                avatar={
                                    <Avatar className="avatar-item pointer" onClick={() => _detail(result.transaction.id, result.user.id)}>
                                        <FaDownload />
                                    </Avatar>
                                }
                                title={<h6 className="fw-bold bs-color-b pointer" onClick={() => _detail(result.transaction.id, result.user.id)}>{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(result.transaction.transaction_amount)}</h6>}
                                subheader={
                                    <>
                                        <span className="d-block bs-color mb-2 pointer" onClick={() => _detail(result.transaction.id, result.user.id)}>Horário: {new Intl.DateTimeFormat('pt-BR', {year: '2-digit', month: '2-digit',day: '2-digit'}).format(new Date(result.cota.paid_at))} {new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(result.cota.paid_at))}</span>
                                        <span className="pointer fw-bold text-danger" onClick={() => _handleRedirectView(result?.transaction?.id, result?.cota?.campaign_url) }>Ver Compra</span>
                                    </>
                                }
                            />
                        </>
                    }
                </>
                }

                {(result.cota) &&
                <>
                {(result.cota.awarded) &&
                    <>
                        <hr className="hr-muted"/>
                        <div className="alert alert-success" role="alert">
                            <h4 className='fw-bold'>Parabéns!!!</h4>
                            <p className="mb-0">
                                <strong>Título contemplado</strong> na modalidade <strong>Premiação Instantânea.</strong>
                            </p>
                        </div>
                    </>
                }
                </>
                }
            </div>
        </div>
    )
}